<template>
  <div>
    <div id="fieldtrialform">
      <!-- content header: fieldtrial form -->
      <div id="field_trial_header" class="field_trial_header">
        <h2>
          <b>{{ $t("fieldTrialRegist.header") }}</b>
        </h2>
      </div>

      <!-- field trial form body -->
      <div class="field_trial_body">
        <!-- start field trial form -->
        <div>
          <div class="field_trial_wrapper">
            <div>
              <div class="alert">{{ $t("contactform.msg_success") }}</div>
              <form
                id="contactForm"
                @submit.prevent="sendEmailjs('fieldtrial')"
                ref="formFieldtrial"
              >
                <b-row>
                  <b-col cols="4">
                    <!-- firstname -->
                    <div>
                      <h4>
                        <label
                          ><b>{{
                            $t("fieldTrialRegist.fNameParent")
                          }}</b></label
                        >
                      </h4>
                      <input
                        required
                        name="firstname"
                        id="firstname"
                        class="reduceInputHeight"
                      />
                      <span id="s_firstname" class="warning"></span>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <!-- midname -->
                    <div>
                      <h4>
                        <label
                          ><b>{{
                            $t("fieldTrialRegist.mNameParent")
                          }}</b></label
                        >
                      </h4>
                      <input
                        name="middlename"
                        id="middlename"
                        class="reduceInputHeight"
                      />
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <!-- lastname -->
                    <div>
                      <h4>
                        <label
                          ><b>{{
                            $t("fieldTrialRegist.lNameParent")
                          }}</b></label
                        >
                      </h4>
                      <input
                        required
                        type="required"
                        name="lastname"
                        id="lastname"
                        class="reduceInputHeight"
                      />
                      <span id="s_lastname" class="warning"></span>
                    </div>
                  </b-col> </b-row
                ><br />

                <b-row>
                  <b-col>
                    <!-- email -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.emailAddress") }}</b></label
                      >
                    </h4>
                    <input
                      required
                      type="text"
                      name="emailaddress"
                      id="emailaddress"
                      class="reduceInputHeight"
                    />
                    <span id="s_emailaddress" class="warning"></span>
                  </b-col>
                  <b-col>
                    <!-- phone -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.phoneNumber") }}</b></label
                      >
                    </h4>
                    <input
                      required
                      type="text"
                      name="phone"
                      id="phone"
                      class="reduceInputHeight"
                    />
                    <span id="s_phone" class="warning"></span>
                  </b-col>
                </b-row>
                <br />

                <b-row>
                  <b-col cols="4">
                    <!-- child firstname -->
                    <div>
                      <h4>
                        <label
                          ><b>{{ $t("fieldTrialRegist.fNameChild") }}</b></label
                        >
                      </h4>
                      <input
                        required
                        type="required"
                        name="childfirstname"
                        id="childfirstname"
                        class="reduceInputHeight"
                      />
                      <span id="s_childfirstname" class="warning"></span>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <!-- childe middlename -->
                    <div>
                      <h4>
                        <label
                          ><b>{{ $t("fieldTrialRegist.mNameChild") }}</b></label
                        >
                      </h4>
                      <input
                        name="childmiddlename"
                        id="childmiddlename"
                        class="reduceInputHeight"
                      />
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <!-- child lastname -->
                    <div>
                      <h4>
                        <label
                          ><b>{{ $t("fieldTrialRegist.lNameChild") }}</b></label
                        >
                      </h4>
                      <input
                        required
                        type="required"
                        name="childlastname"
                        id="childlastname"
                        class="reduceInputHeight"
                      />
                      <span id="s_childlastname" class="warning"></span>
                    </div>
                  </b-col> </b-row
                ><br />

                <b-row>
                  <b-col cols="4">
                    <!-- child preferredname -->
                    <div>
                      <h4>
                        <label
                          ><b>{{ $t("fieldTrialRegist.pNameChild") }}</b></label
                        >
                      </h4>
                      <input
                        name="childpreferredname"
                        id="childpreferredname"
                        class="reduceInputHeight"
                      />
                      <span id="s_childpreferredname" class="warning"></span>
                    </div>
                  </b-col>
                  <b-col cols="4">
                    <!-- kid gender -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.childGender") }}</b></label
                      >
                    </h4>

                    <b-form-group>
                      <b-form-radio-group
                        id="childgender"
                        v-model="selectedGender"
                        :options="$t('fieldTrialRegist.genderOptions')"
                        name="childgender"
                        stacked
                      ></b-form-radio-group>
                    </b-form-group>
                    <span id="s_childgender" class="warning"></span>
                  </b-col>

                  <b-col cols="4">
                    <!-- age -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.agePartic") }}</b></label
                      >
                    </h4>

                    <div>
                      <VueDatePicker
                        name="birth"
                        id="birth"
                        style="display: inline-block"
                        v-model="birth_date"
                        :max-date="maxDate"
                        fullscreen-mobile
                      />
                      <br />
                      <span id="s_birth" class="warning"></span>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <!-- address -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.address") }}</b></label
                      >
                    </h4>
                    <input
                      required
                      type="text"
                      name="address"
                      rows="5"
                      id="address"
                      class="reduceInputHeight"
                    />
                    <span id="s_address" class="warning"></span>
                  </b-col>
                  <b-col cols="4">
                    <!-- zip -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.zip&post") }}</b></label
                      >
                    </h4>
                    <input
                      required
                      type="required"
                      name="zip"
                      id="zip"
                      class="reduceInputHeight"
                    />
                    <span id="s_zip" class="warning"></span>
                  </b-col>
                </b-row>
                <br />
                <b-row>
                  <b-col cols="4">
                    <!-- city -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.city") }}</b></label
                      >
                    </h4>
                    <input
                      required
                      type="required"
                      name="city"
                      id="city"
                      class="reduceInputHeight"
                    />
                    <span id="s_city" class="warning"></span>
                  </b-col>
                  <b-col cols="4">
                    <!-- state -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.state&prov") }}</b></label
                      >
                    </h4>
                    <input
                      required
                      type="required"
                      name="state"
                      id="state"
                      class="reduceInputHeight"
                    />
                    <span id="s_state" class="warning"></span>
                  </b-col>
                  <b-col>
                    <!-- country -->
                    <h4>
                      <label
                        ><b>{{ $t("fieldTrialRegist.country") }}</b></label
                      >
                    </h4>
                    <select
                      required
                      id="country"
                      name="country"
                      style="width: 100%"
                      class="reduceInputHeight"
                    >
                      <option>United States</option>
                      <option>Germany</option>
                      <option>France</option>
                      <option>China</option>
                      <option>Brazil</option>
                      <option>Argentina</option>
                    </select>
                  </b-col>
                </b-row>
                <br />
                <b-row style="width: 100%; position: relative; left: 1%">
                </b-row>
                <br />
                <br />
                <br /><br />
                <!-- waiver download -->
                <b-row>
                  <b-col cols="8">
                    <b-button
                      style="
                        padding: 7px;
                        margin-left: 0px;
                        background-color: #f4892f;
                      "
                      type="button"
                      @click="createDOC()"
                    >
                      {{ $t("fieldTrialRegist.downloadSignWaiver") }}
                    </b-button>
                  </b-col>
                </b-row>

                <!-- waiver upload -->
                <b-row>
                  <b-col cols="8">
                    <form action="">
                      <label for="myfile">{{
                        $t("fieldTrialRegist.uploadWaiver")
                      }}</label>
                      <input
                        type="file"
                        id="upload"
                        name="myfile"
                        @change="uploadFile"
                        accept="application/pdf,application/zip"
                      />
                      <span id="s_upload" class="warning"></span>
                    </form>
                  </b-col>
                </b-row>
                <br />
                <br />

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[0].header")
                      }}</b></label
                    >
                  </b-col>
                </b-row>

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <!-- select -->
                    <b-form-checkbox-group
                      id="select"
                      v-model="specificQuestions[0].selectedAnswers"
                      :options="
                        $t(
                          'fieldTrialRegist.specificQuestions[0].answerOptions'
                        )
                      "
                      stacked
                    ></b-form-checkbox-group>
                    <span id="s_select" class="warning"></span>
                  </b-col>
                </b-row>
                <br />

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[0].text")
                      }}</b></label
                    >
                    <textarea name="issueDetail" id="issueDetail" v-model="specificQuestions[0].issueDetail" rows="4" cols="50"></textarea>
                  </b-col>
                </b-row>
                

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[1].header")
                      }}</b></label
                    >
                  </b-col>
                </b-row>

                <b-row style="width: 90%; position: relative; left: 5%">
                  <!-- pick1 -->
                  <b-col cols="8">
                    <b-form-radio-group
                      id="pick1"
                      v-model="specificQuestions[1].selectedAnswer"
                      :options="
                        $t(
                          'fieldTrialRegist.specificQuestions[1].answerOptions'
                        )
                      "
                      stacked
                      class="text-dark"
                    ></b-form-radio-group>
                    <span id="s_pick1" class="warning"></span>
                  </b-col>
                </b-row>
                <br />

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[2].header")
                      }}</b></label
                    >
                  </b-col>
                </b-row>

                <!-- pick2 -->
                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <b-form-radio-group
                      id="pick2"
                      v-model="specificQuestions[2].selectedAnswer"
                      :options="
                        $t(
                          'fieldTrialRegist.specificQuestions[2].answerOptions'
                        )
                      "
                      stacked
                      class="text-dark"
                    ></b-form-radio-group>
                    <span id="s_pick2" class="warning"></span>
                  </b-col>
                </b-row>
                <br />

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[3].header")
                      }}</b></label
                    >
                  </b-col>
                </b-row>

                <!-- pick3 -->
                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <b-form-radio-group
                      id="pick3"
                      v-model="specificQuestions[3].selectedAnswer"
                      :options="
                        $t(
                          'fieldTrialRegist.specificQuestions[3].answerOptions'
                        )
                      "
                      stacked
                      class="text-dark"
                    ></b-form-radio-group>
                    <span id="s_pick3" class="warning"></span>
                  </b-col>
                </b-row>

                <br />

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[4].header")
                      }}</b></label
                    >
                  </b-col>
                </b-row>

                <!-- pick4 -->
                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <b-form-radio-group
                      id="pick4"
                      v-model="specificQuestions[4].selectedAnswer"
                      :options="
                        $t(
                          'fieldTrialRegist.specificQuestions[4].answerOptions'
                        )
                      "
                      stacked
                      class="text-dark"
                    ></b-form-radio-group>
                    <span id="s_pick4" class="warning"></span>
                  </b-col>
                </b-row>
                <br />
                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <label
                      ><b>{{
                        $t("fieldTrialRegist.specificQuestions[5].header")
                      }}</b></label
                    >
                  </b-col>
                </b-row>
                <!-- distance -->
                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col cols="8">
                    <b-form-group>
                      <b-form-radio-group
                        id="distance"
                        name="distance"
                        v-model="selectedDistance"
                        :options="
                          $t(
                            'fieldTrialRegist.specificQuestions[5].answerOptions'
                          )
                        "
                        stacked
                      ></b-form-radio-group>
                      <span id="s_distance" class="warning"></span>
                    </b-form-group>
                  </b-col> </b-row
                ><br />

                <div style="width: 50%; height: auto">
                  <b-row>
                    <b-col cols="8">
                      <!-- pick date -->
                      <label
                        ><b
                          >{{ $t("fieldTrialRegist.dateQuestion") }}*(Maximum of
                          2 selections allowed.)
                          </b
                        >
                        </label
                      >
                    </b-col>
                  
                    
                    <b-col cols="10">
                      <input type="button" value="add" @click="addOnsiteDateAndTime">
                      
                      <div style="display: flex; align-items: center; gap: 8px;">
                        <VueDatePicker
                          v-if="showDatePicker1"
                          v-model="datePicker1"
                          name="showDatePicker1"
                        />
                        <vue-timepicker
                          v-if="showDatePicker1"
                          v-model="timePicker1"
                          format="hh:mm a"
                          close-on-complete
                          manual-input
                          name="timePicker1"
                        />
                        <img src="../img/NLC new website/trash.svg" alt="remove" v-if="showDatePicker1" @click="removeDateAndTimePicker('1')">
                      </div>

                      <div style="display: flex; align-items: center; gap: 8px;">
<VueDatePicker
                        v-if="showDatePicker2"
                        v-model="datePicker2"
                        name="showDatePicker2"
                      />
                      <vue-timepicker
                          v-if="showDatePicker2"
                          v-model="timePicker2"
                          format="hh:mm a"
                          close-on-complete
                          manual-input
                          name="timePicker2"
                        /><img src="../img/NLC new website/trash.svg" alt="remove" v-if="showDatePicker2"  @click="removeDateAndTimePicker('2')">
                      </div>

                      <!-- <div style="display: flex; align-items: center; gap: 8px;">
                        <VueDatePicker
                        v-if="showDatePicker3"
                        v-model="datePicker3"
                        name="showDatePicker3"
                      />
                      <vue-timepicker
                          v-if="showDatePicker3"
                          v-model="timePicker3"
                          format="hh:mm a"
                          close-on-complete
                          manual-input
                          name="timePicker3"
                        /><img src="../img/NLC new website/trash.svg" alt="remove" v-if="showDatePicker3" @click="removeDateAndTimePicker('3')">
                      </div>

                      <div style="display: flex; align-items: center; gap: 8px;">
                        <VueDatePicker
                        v-if="showDatePicker4"
                        v-model="datePicker4"
                        name="showDatePicker4"
                      />
                      <vue-timepicker
                          v-if="showDatePicker4"
                          v-model="timePicker4"
                          format="hh:mm a"
                          close-on-complete
                          manual-input
                          name="timePicker4"
                        /><img src="../img/NLC new website/trash.svg" alt="remove" v-if="showDatePicker4" @click="removeDateAndTimePicker('4')">
                      </div>

                      <div style="display: flex; align-items: center; gap: 8px;">
                        <VueDatePicker
                        v-if="showDatePicker5"
                        v-model="datePicker5"
                        name="showDatePicker5"
                      />
                      <vue-timepicker
                          v-if="showDatePicker5"
                          v-model="timePicker5"
                          format="hh:mm a"
                          close-on-complete
                          manual-input
                          name="timePicker5"
                        /><img src="../img/NLC new website/trash.svg" alt="remove" v-if="showDatePicker5" @click="removeDateAndTimePicker('5')">
                      </div> -->
                      <span id="s_onsite" class="warning"></span>
                    </b-col> 
                    </b-row
                  ><br />

                  <!-- <b-row>
                    <b-col cols="8">
                      
                      <div v-for="(date, index) in date" v-bind:key="index">
                        <label
                          ><b
                            >Your available time slot(s) on
                            {{ formatDate(date) }}</b
                          ></label
                        >

                        <select
                          name="pickTime"
                          v-if="date.getDay() == 0 || date.getDay() == 6"
                          multiple="true"
                          v-model="selectedTimesByDate[formatDate(date)]"
                          :id="getTimeSlotID(index)"
                        >
                          <option>12:00 PM - 1:30 PM</option>
                          <option>1:45 PM - 3:15 PM</option>
                          <option>3:30 PM - 5:00 PM</option>
                          <option>5:15 PM - 6:45 PM</option>
                        </select>
            
                        <select
                          name="pickTime"
                          v-model="selectedTimesByDate[formatDate(date)]"
                          v-else-if="date.getDay() == 2"
                          multiple="true"
                          :id="getTimeSlotID(index)"
                        >
                          <option>9:00 AM - 10:30 AM</option>
                          <option>10:45 AM - 12:15 AM</option>
                          <option>12:30 AM - 2:00 AM</option>
                          <option>2:15 PM - 3:45 PM</option>
                          <option>4:00 PM - 5:30 PM</option>
                        </select>
                  
                        <select
                          name="pickTime"
                          v-model="selectedTimesByDate[formatDate(date)]"
                          v-else-if="date.getDay() == 3"
                          multiple="true"
                          :id="getTimeSlotID(index)"
                        >
                          <option>1:00 PM - 2:30 PM</option>
                          <option>2:45 PM - 4:15 PM</option>
                          <option>4:30 PM - 6:00 PM</option>
                        </select>
                 
                        <div v-else multiple="true" :id="getTimeSlotID(index)">
                          <span>Not available</span>
                        </div>
                      </div>

                      <div
                        v-for="(times, date) in selectedTimesByDate"
                        :key="date"
                      >
                        <h4>{{ date }}</h4>
                        <ul>
                          <li v-for="(time, index) in times" :key="index">
                            {{ time }}
                          </li>
                        </ul>
                      </div>

                      <span id="s_onsite_time" class="warning"></span>
                      <br />
                    </b-col> </b-row
                  ><br /> -->

                  <b-row>
                    <b-col cols="10">
                      <label
                        ><b> {{ $t("fieldTrialRegist.timePickup") }}*</b></label
                      >
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="8">
                      <label>
                        <input
                          type="radio"
                          name="choice1"
                          id="dropChild"
                          v-model="dropOffChild"
                          :value="true"
                          @change="handleDropOffChildChange"
                        />
                        Drop off child
                      </label>
                      
                      <label>
                        <input
                          type="radio"
                          name="choice2"
                          id="stayChild"
                          v-model="stayWithChild"
                          :value="true"
                          @change="handleStayWithChildChange"
                        />
                        Stay with child
                      </label>
                    </b-col>
                    <br>
                    
                  </b-row>
                  <span id="s_pickup" class="warning"></span>
                  <br /><br /><br />

                  <b-row>
                    <b-col cols="8">
                      <label
                        ><b>{{ $t("fieldTrialRegist.anyComments") }}</b></label
                      >
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="8">
                      <!-- comment -->
                      <b-form-textarea
                        name="message"
                        id="textarea"
                        v-model="otherComments"
                        placeholder="Other comments"
                        rows="8"
                      >
                      </b-form-textarea>
                    </b-col>
                  </b-row>
                </div>

                <b-row style="width: 90%; position: relative; left: 5%">
                  <b-col>
                    <b-button
                      id="submit"
                      round
                      class="text-dark"
                      style="text-align: center; box-shadow: 1px 1px 2px #333"
                    >
                      <b>{{ $t("fieldTrialRegist.submit") }}</b>
                    </b-button>
                  </b-col>
                </b-row>
              </form>
            </div>
            <img
              id="bottom_img"
              src="../img/bottom_of_the_form.png"
              alt="bottom_of_the_form"
            />
            <br />
          </div>
        </div>
        <!-- end contactform -->
      </div>
      <div>
        <b-modal
          id="modal-1"
          v-model="showThankyouModal"
          footer-class="custom-footer"
        >
          <h2 style="font-family: 'Mandrope', sans-serif">
            Thank you for your submission!
          </h2>
          <br />
          <p style="font-family: 'Mandrope', sans-serif">
            We will get back to you soon.
          </p>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>

import instance from "../axios";

import { init } from "emailjs-com";
import emailJS from "../services/emailJS";

import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  AlignmentType,
  Header,
  Footer,
} from "docx";
import { saveAs } from "file-saver";

init("user_4emeb9XisHrwOnwGddizV");
const today = new Date();

export default {
  name: "fieldTrialRegistration",

  data() {
    return {
      showThankyouModal: false,
      availableTimes: [10, 20],
      multi: true,
      date: [],
      pickedDate:null,
      selectedTimesByDate: {},
      remainedDatePicker:[1,2],
      showDatePicker1:false,
      datePicker1:null,
      timePicker1:"",
      showDatePicker2:false,
      datePicker2:null,
      timePicker2:"",
      // showDatePicker3:false,
      // datePicker3:null,
      // timePicker3:"",
      // showDatePicker4:false,
      // datePicker4:null,
      // timePicker4:"",
      // showDatePicker5:false,
      // datePicker5:null,
      // timePicker5:"",
      disableOnsite: false,
      birth_date: null,
      maxDate: `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`,

      selectedGender: "",
      genderOptions: ["Male", "Female", "Gender Variant/Non-binary"],
      selectedDistance: "",
      otherComments: "",
      pickup: "",
      distanceOptions: [
        "25 miles",
        "50 miles",
        "100 miles",
        "250 miles",
        "Any distance",
      ],

      specificQuestions: [
        {
          header: "Select all applicable skills your child has trouble with:*",
          answerOptions: [
            "a) Gross motor skills: Difficulties in movements involving larger muscles (arms, legs, etc). Examples: moving legs/arms in full range of motion, head control, jumping/walking/running.",
            "b) Fine motor skills: Difficulties in movements involving their fingers, hands or wrists. Examples: writing, typing, grabbing/grasping, control of fingers/hands.",
            "c) Cognitive skills: Challenges in achieving cognitive/developmental milestones. Examples: eye contact, facial expression recognition/imitation, and others.",
            "d) Mental Health: Challenges in emotional, psychological, and social well-being. Examples: depression, Autism spectrum disorder (ASD), anxiety disorders.",
            "e) Speech & Language skills: Challenges to understand, process, and express thoughts effectively. Examples: comprehension, production/expression, clarity of speech.",
            "f) Attention: Difficulties with focus, shifting attention, and filtering distractions. Examples: Attention-Deficit/Hyperactivity Disorder (ADHD), Executive Function Disorder (EFD).",
            "g) School-related tasks: Issues in learning activities and social interaction. Examples: reading comprehension, writing, tracing, issues with group work or individual work, and others.",
            "h) N/A (no delays/significant issues)"
          ],
          selectedAnswers: [],
          issueDetail:""
        },

        {
          header: "How severe would you say your child’s delays are?*",
          answerOptions: [
            "a) Very severe/Profound",
            "b) Severe",
            "c) Moderately severe",
            "d) Moderate",
            "e) Mild to Low",
            "f) N/A (no delays/significant issues)",
          ],
          selectedAnswer: "No answer selected",
        },

        {
          header:
            "If your child is in school, what have your child’s teachers/school administrators said in regards to their motor development?*",
          answerOptions: [
            "a) Very concerned",
            "b) Concerned",
            "c) Moderately concerned",
            "d) Some concerns",
            "e) No concerns",
            "f) N/A (not of school age)",
            "g) N/A (homeschooled)",
            "h) N/A (unable to contact teachers)",
            "i) N/A (no delays/significant issues)",
          ],
          selectedAnswer: "No answer selected",
        },

        {
          header:
            "If your child is in school, what have your child’s teachers/school administrators said in regards to their cognitive/learning development?*",
          answerOptions: [
            "a) Very concerned",
            "b) Concerned",
            "c) Moderately concerned",
            "d) Some concerns",
            "e) No concerns",
            "f) N/A (not of school age)",
            "g) N/A (homeschooled)",
            "h) N/A (unable to contact teachers)",
            "i) N/A (no delays/significant issues)",
          ],
          selectedAnswer: "No answer selected",
        },

        {
          header:
            "If you have brought your child to see a specialist in the past year, or if they have seen a specialist in their school or another organization, what have they said in regards to your child’s motor/cognitive/learning development?*",
          answerOptions: [
            "a) Very concerned",
            "b) Concerned",
            "c) Moderately concerned",
            "d) Some concerns",
            "e) No concerns",
            "f) N/A (has not seen a specialist)",
            "g) N/A (no delays/significant issues)",
          ],
          selectedAnswer: "No answer selected",
        },
      ],
      scanResult: "",
      stayWithChild: false,
      dropOffChild:false
    };
  },
  mounted: function () {
    this.selectedTimesByDate = this.date.map(() => []);
    this.goTop();
    this.check();
  },
  components: {
    VueDatePicker,
    VueTimepicker
  },
  watch: {
    date: {
      handler(newDates) {
        newDates.forEach((date) => {
          const key = this.formatDate(date);
          if (!Array.isArray(this.selectedTimesByDate[key])) {
            this.$set(this.selectedTimesByDate, key, []);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    selectedTimesByDate: {
      deep: true,
      immediate: false,
      handler(newVal) {
        const allSelected = Object.keys(newVal).length;
        if (allSelected >= 5) {
          alert("You can only select up to 5 time slots.");
          for (const date in newVal) {
            if (newVal[date].length > 0) {
              newVal[date].pop(); // remove last selected
              break; // remove only one
            }
          }
        }
      },
    },
    // pickup(newVal) {
    //   if (newVal) {
    //     this.stayWithChild = false;
    //   }
    // },
  },

  methods: {
    async uploadFile(event) {
      // make sure scan result is empty whenever new file is uploaded
      this.scanResult = "";
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("myfile", file);

      try {
        const response = await instance.post("/api/scanFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.message == "No Threat Detected") {
          this.scanResult = response.data.message;
          alert(
            "Your file verification is finished, you may submit the form now."
          );
        } else {
          this.scanResult = response.data.message;
          alert(
            "There are some issues with your file, please edit and upload again."
          );
        }
      } catch (error) {
        console.error("Error uploading file");
        alert(
          "There are issues with our file service, please use the Contact Us form in home page."
        );
      }
    },
    check() {
      var vm = this;
      // if any required block is empty, prevent submitting form
      document.getElementById("submit").onclick = function (event) {
        var flag_submit = checkList();
        if (!flag_submit) {
          alert("Please fill in all required information");
          return;
        }
        if (vm.scanResult == "No Threat Detected" && flag_submit) {
          // vm.createInstance();
          vm.sendEmailjs("fieldtrial");
        } else if (vm.scanResult != "" || !flag_submit) {
          alert(
            "There are some issues with your file or input, please edit and submit again."
          );
        } else {
          event.preventDefault();
          alert(
            "We are verifying your waiver file, please wait for a few seconds and try again"
          );
        }
      };

      function checkList() {
        var c1 = checkEmpty("firstname");
        var c3 = checkEmpty("lastname");
        var c4 = checkEmail("emailaddress");
        var c5 = checkEmpty("childfirstname");
        var c7 = checkEmpty("childlastname");
        var c8 = checkPick("childgender");
        var c9 = checkEmpty("phone");
        var c10 = checkEmpty("address");
        var c11 = checkEmpty("city");
        var c12 = checkEmpty("state");
        var c13 = checkEmpty("zip");
        var c14 = checkSelect("select");
        var c15 = checkSelect("pick1");
        var c16 = checkSelect("pick2");
        var c17 = checkSelect("pick3");
        var c18 = checkSelect("pick4");
        var c19 = checkDistance("distance");
        var c21 = checkUpload();
        var c22 = checkBirth("birth");
        var c23 = false;
        var s_onsite = document.getElementById("s_onsite");
        if (vm.remainedDatePicker.length != 5) {
          if ((vm.datePicker1!=null && vm.timePicker1=="") || (vm.datePicker1==null && vm.timePicker1!="")){
            c23 = false;
            s_onsite.innerHTML = "Warning: Please choose a date and time";
          }
          else if ((vm.datePicker2!=null && vm.timePicker2=="") || (vm.datePicker2==null && vm.timePicker2!="")){
            c23 = false;
            s_onsite.innerHTML = "Warning: Please choose a date and time";
          }
          // else if ((vm.datePicker3!=null && vm.timePicker3=="") || (vm.datePicker3==null && vm.timePicker3!="")){
          //   c23 = false;
          //   s_onsite.innerHTML = "Warning: Please choose a date and time";
          // }
          // else if ((vm.datePicker4!=null && vm.timePicker4=="") || (vm.datePicker4==null && vm.timePicker4!="")){
          //   c23 = false;
          //   s_onsite.innerHTML = "Warning: Please choose a date and time";
          // }
          // else if ((vm.datePicker5!=null && vm.timePicker5=="") || (vm.datePicker5==null && vm.timePicker5!="")){
          //   c23 = false;
          //   s_onsite.innerHTML = "Warning: Please choose a date and time";
          // }
          else{
c23 = true;
          s_onsite.innerHTML = "";
          }
          
        } 
        else{
          c23 = false;
            s_onsite.innerHTML = "Warning: Please choose a date and time";
        }
        // var c24 = false;
        // var s_onsite_time = document.getElementById("s_onsite_time");
        // if (Object.keys(vm.selectedTimesByDate).length != 0) {
        //   c24 = true;
        //   s_onsite_time.innerHTML = "";
        // } else {
        //   c24 = false;
        //   s_onsite_time.innerHTML = "Warning: Please choose a time slot";
        // }
        var c25 = false;
        var s_pickup = document.getElementById("s_pickup");
        if (vm.dropOffChild == true && vm.stayWithChild == false) {
          c25 = true;
          s_pickup.innerHTML = "";
        } 
        else if(vm.dropOffChild == false && vm.stayWithChild == true){
          c25 = true;
          s_pickup.innerHTML = "";
        }
        else {
          c25 = false;
          s_pickup.innerHTML = "Warning: Please select";
        }
        if (
          c1 &&
          c3 &&
          c4 &&
          c5 &&
          c7 &&
          c8 &&
          c9 &&
          c10 &&
          c11 & c12 &&
          c13 &&
          c14 &&
          c15 &&
          c16 &&
          c17 &&
          c18 &&
          c19 &&
          c21 &&
          c22 &&
          c23 &&
          
          c25
        ) {
          return true;
        } else {
          return false;
        }
      }

      function checkEmail(name) {
        var val = document.getElementById(name).value;
        var reg = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
        var flag = reg.test(val);
        var s_val = document.getElementById("s_" + name);
        if (flag) {
          s_val.innerHTML = "";
        } else {
          s_val.innerHTML = "Warning: Please fill in correct email";
        }
        return flag;
      }
      function checkBirth(name) {
        var val = document.getElementById(name).value;
        var reg = /^$/;
        var flag = !reg.test(val);
        var s_val = document.getElementById("s_" + name);
        if (flag) {
          s_val.innerHTML = "";
        } else {
          s_val.innerHTML = "Warning: Please select birth date";
        }
        return flag;
      }
      // check text input valid
      function checkEmpty(name) {
        var val = document.getElementById(name).value;
        const reg = /^.{2,}$/;
        var flag = reg.test(val);
        var s_val = document.getElementById("s_" + name);
        if (flag) {
          s_val.innerHTML = "";
        } else {
          s_val.innerHTML = "Warning: At least two characters";
        }
        return flag;
      }
      // check pick input valid
      function checkPick(name) {
        var val = vm.selectedGender;
        var s_val = document.getElementById("s_" + name);
        if (val != "") {
          s_val.innerHTML = "";
          return true;
        } else {
          s_val.innerHTML = "Warning: Please choose one";
          return false;
        }
      }
      function checkSelect(name) {
        var val;
        if (name == "select") {
          val = vm.specificQuestions[0].selectedAnswers;
        } else if (name == "pick1") {
          val = vm.specificQuestions[1].selectedAnswer;
        } else if (name == "pick2") {
          val = vm.specificQuestions[2].selectedAnswer;
        } else if (name == "pick3") {
          val = vm.specificQuestions[3].selectedAnswer;
        } else if (name == "pick4") {
          val = vm.specificQuestions[4].selectedAnswer;
        }

        var s_val = document.getElementById("s_" + name);
        if (name == "select") {
          if (val != "") {
            s_val.innerHTML = "";
            return true;
          } else {
            s_val.innerHTML = "Warning: Please select at least one";
            return false;
          }
        } else {
          if (val != "No answer selected") {
            s_val.innerHTML = "";
            return true;
          } else {
            s_val.innerHTML = "Warning: Please select";
            return false;
          }
        }
      }
      function checkDistance(name) {
        var val = vm.selectedDistance;
        var s_val = document.getElementById("s_" + name);
        if (val != "") {
          s_val.innerHTML = "";
          return true;
        } else {
          s_val.innerHTML = "Warning: Please select";
          return false;
        }
      }

      function checkUpload() {
        var val = document.getElementById("upload").value;
        // console.log(val);
        var s_val = document.getElementById("s_upload");
        if (val != "") {
          s_val.innerHTML = "";
          return true;
        } else {
          s_val.innerHTML = "Warning: Please upload signed waiver";
          return false;
        }
      }
    },
    handleStayWithChildChange() {
      if (this.stayWithChild) {
        this.dropOffChild = false;
      }
    },
    handleDropOffChildChange() {
      if (this.dropOffChild) {
        this.stayWithChild = false;
      }
    },
    createInstance(timestamp) {
      const formData = new FormData();
      formData.append("fileid", document.getElementById("firstname").value+document.getElementById("lastname").value+timestamp);
      formData.append("firstname", document.getElementById("firstname").value);
      formData.append(
        "middlename",
        document.getElementById("middlename").value
      );
      formData.append("lastname", document.getElementById("lastname").value);
      formData.append("email", document.getElementById("emailaddress").value);
      formData.append("phone", document.getElementById("phone").value);
      formData.append(
        "childfirstname",
        document.getElementById("childfirstname").value
      );
      formData.append(
        "childmiddlename",
        document.getElementById("childmiddlename").value
      );
      formData.append(
        "childlastname",
        document.getElementById("childlastname").value
      );
      formData.append(
        "childpreferredname",
        document.getElementById("childpreferredname").value
      );
      formData.append("gender", this.selectedGender);
      formData.append("birth", this.birth_date);
      formData.append("address", document.getElementById("address").value);
      formData.append("zip", document.getElementById("zip").value);
      formData.append("city", document.getElementById("city").value);
      formData.append("state", document.getElementById("state").value);
      formData.append("country", document.getElementById("country").value);

      formData.append(
        "anw1",
        JSON.stringify(this.specificQuestions[0].selectedAnswers)
      );
      formData.append(
        "issuedetail",
        this.specificQuestions[0].issueDetail
      );
      formData.append("anw2", this.specificQuestions[1].selectedAnswer);
      formData.append("anw3", this.specificQuestions[2].selectedAnswer);
      formData.append("anw4", this.specificQuestions[3].selectedAnswer);
      formData.append("anw5", this.specificQuestions[4].selectedAnswer);
      formData.append("distance", this.selectedDistance);

      var dateAndTimePicked = []
      for (var i=1; i<3; i++){
        var date = this['datePicker' + i]
        var time = this['timePicker' + i]
        if (date!=null && time!=""){
          dateAndTimePicked.push(date+"&"+time)
        }
        else if (date==null && time!=""){
          console.log(i,date,time)
          alert("Please finish date-time selection")
          return
        }
        else if (date!=null && time==""){
          console.log(i,date,time)
          alert("Please finish date-time selection")
          return
        }
        else{
          continue
        }
      }
      formData.append("availDate", dateAndTimePicked.join(","));

      formData.append("drop", JSON.stringify(this.dropOffChild));
      formData.append("stay", JSON.stringify(this.stayWithChild));
      formData.append("comment", this.otherComments);
      instance
        .post("api/createFieldTrial", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          console.log("success save field trial info");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addOnsiteDateAndTime() {
      if (this.remainedDatePicker.length==0){
        alert("Maximum of 2 selections allowed")
        return
      }
      const elem = this.remainedDatePicker.shift()
      this['showDatePicker' + elem] = true;
    },
    removeDateAndTimePicker(targetID){
      this.remainedDatePicker.push(parseInt(targetID))
      this['showDatePicker' + targetID] = false;
      this['datePicker' + targetID] = null;
      this['timePicker' + targetID] = "";
    },

    sendEmailjs(from) {
      // scan in progress, no email
      if (this.scanResult == "") {
        alert(
          "We are verifying your waiver file, please wait for a few seconds and try again"
        );
        return;
      }
      // scan finished, no virus, send email
      else if (this.scanResult == "No Threat Detected") {
        if (from == "fieldtrial") {
          const form = this.$refs.formFieldtrial;
          emailJS.sendEmail(from, form);
          // save file in server side
          var pdfFile = document.getElementById("upload");
          var firstname = document.getElementById("firstname");
          var lastname = document.getElementById("lastname");
          var timestamp = new Date().getTime().toString();
          const f = pdfFile.files[0];
          const formData = new FormData();
          formData.append("myfile", f);
          formData.append("firstname", firstname.value);
          formData.append("lastname", lastname.value);
          formData.append("time", timestamp);
          instance
            .post("/api/uploadFieldTrial", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              console.log("Upload successful:", response.data);
            })
            .catch((error) => {
              console.error("Upload failed:", error);
            });
          // reset data
          this.scanResult = "";
          this.showThankyouModal = true;

          this.createInstance(timestamp)
        }
      }
      // scan finished, virus found or service error
      else {
        alert(
          "There are some issues with your waiver file, please edit and upload again, or you can reach out through Contact Us form at home page."
        );
        this.scanResult = "";
        return;
      }
    },

    getTimeSlotID(index) {
      return "timeSlot" + (index + 1);
    },

    formatDate(date) {
      // console.log(this.selectedTimesByDate);
      var retDate = date.toLocaleDateString();
      return retDate.substring(0, 10);
    },

    createDOC() {
      const doc = new Document({
        sections: [
          {
            properties: {},
            headers: {
              default: new Header({
                children: [
                  new Paragraph(
                    "NeuroLeap: Special Power for Special Children"
                  ),
                ],
              }),
              alignment: AlignmentType.RIGHT,
            },
            footers: {
              default: new Footer({
                children: [
                  new Paragraph(
                    "Neuro Leap Corp. Strictly Confidential & Copyright 2021, Updated: March 2021"
                  ),
                ],
                color: "gray",
              }),
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Medical Release / Waiver of Liability Form",
                    bold: true,
                    font: "Calibri",
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Effective from " + new Date().toDateString(),
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text:
                      document.getElementById("firstname").value +
                      " " +
                      document.getElementById("middlename").value +
                      " " +
                      document.getElementById("lastname").value +
                      " (hereinafter the “Releasing Parent(s)”) on behalf of " +
                      document.getElementById("childfirstname").value +
                      " " +
                      document.getElementById("childmiddlename").value +
                      " " +
                      document.getElementById("childlastname").value +
                      ", (the “Child”) freely consent to the Child participating in a Virtual Comprehensive Screening of Reading and Language Comprehension and later results sharing (collectively the ”Services”) at a charge of:",
                    font: "Calibri",
                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "(Bold your selected option)",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),

                  new TextRun({
                    text: "\t- No payment.",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "\t\t\t\t- A payment of $300 to be paid to Neuro Leap Corporation.",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "In giving this consent, the Releasing Parent(s) acknowledge having asked all questions necessary to make an informed decision about making use of the Services and such answers have been satisfactory in making such informed decision. Releasing Parent(s) understand and agree that Neuro Leap Corporation, a California corporation (hereinafter the “Company”) only designs the software used in the Services and that the professional making use of the Services in testing and diagnosis of the Child is an independent professional, not affiliated with, or retained by, the Company. Releasing Parent(s) agree the Company does not represent or warrant the safety of the Child while with the professional or traveling to and from the professional’s site, that the professional is an appropriate selection in application of the Services, that the Services are new and innovative and in development, and that the Releasing Parent(s) are free to identify another professional to apply the Services, subject to the Company being free to decline to provide the Services for its own business reasons.",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "In addition, the Releasing Parent(s), on behalf of themselves and the Child (and all the Child’s minor siblings), give permission for all pictures, audio and video of the Releasing Parent(s) and the Child (and all the Child’s minor siblings) taken during the Virtual Comprehensive Screening of Reading and Language Comprehension to be used by the Company in any media format (whether existing now or developed in the future) including but not limited to print, video, social media and web for the Company and assign all copyright and other right title and interest in our likenesses to be so reproduced and used freely by the Company throughout the universe. No names shall be used without the Releasing Parent(s) advance written consent, except after the Child (or the Child’s siblings) reach the age of majority, then only such person’s advance written consent shall be necessary as to that person. ",
                    font: "Calibri",
                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "FINALLY, in consideration for the Services, the sufficiency of which is hereby acknowledged, and to the fullest extent permitted by law, the Releasing Parent(s), on behalf of themselves and the Child (and all the Child’s minor siblings), do hereby waive and agree to hold harmless the Company and the Company’s agents, employees, shareholders, directors, contractors, interns, successors and assigns, and their respective heirs, personal representatives, affiliates, successors and assigns, and any and all persons, firms or corporations liable or who might be claimed to be liable, whether or not herein named (each a “Beneficiary” and collectively the “Beneficiarys”), none of whom admit any liability to the undersigned, but all expressly denying liability, from any and all claims, demands, damages, actions, causes of action or suits of any kind or nature whatsoever, which the Releasing Parent(s) and the Child, and the Child’s siblings, now have or may hereafter have, arising out of or in any way relating to any and all injuries and damages of any and every kind, to both person and property, and also any and all injuries and damages that may develop in the future, as a result of or in any way relating to Virtual Comprehensive Screening of Reading and Language Comprehension and sharing of media and results with Beneficiary’s affiliates and the Releasing Parent(s) and the Child. As noted above, the professional administering the Virtual Comprehensive Screening of Reading and Language Comprehension is independent of the Company and is not an intended beneficiary of this waiver, release and indemnification. If only one of the Releasing Parent(s) has signed below, that person represents and warrants that the other parent has been informed of the Child’s participation in the Services and freely consented to same and the Releasing Parent(s) hereby agrees to indemnify, defend and hold harmless any and all of the Beneficiarys from any and all claims the other parent may assert or the Child or the Child’s other minor siblings.",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),
              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "It is understood and agreed that this Agreement contains the entire agreement between the parties; and that the terms of this Agreement are contractual and not merely a recital and entirely supersede all prior written or oral agreements relating to the subjects set forth herein. Furthermore, this Agreement shall be binding upon each of the undersigned, and the heirs, executors, administrators, personal representatives, successors and assigns of the Releasing Parent(s).",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "This Release shall be subject to and governed by the laws of the State of California, USA.",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "This Release has been read and fully understood by the undersigned and has been explained to us.",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "EXECUTED this date: _____ day of ___________________, 20____",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Location: __________________________________",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Releasing Parent(s)’s Signature(s): _________________________________________",
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text:
                      "Print Name(s): " +
                      document.getElementById("firstname").value +
                      " " +
                      document.getElementById("middlename").value +
                      " " +
                      document.getElementById("lastname").value,
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),

              new Paragraph({
                children: [], // Just newline without text
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text:
                      "residing at: " +
                      document.getElementById("address").value +
                      ", " +
                      document.getElementById("city").value +
                      ", " +
                      document.getElementById("state").value +
                      ", " +
                      document.getElementById("zip").value,
                    font: "Calibri",

                    bold: false,
                    size: 24,
                  }),
                ],
                alignment: AlignmentType.LEFT,
              }),
            ],
          },
        ],
      });

      // Used to export the file into a .docx file
      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "waiver.docx");
      });
    },

    // run automatically
    goTop() {
      window.scrollTo(0, 0);
    },
  },
};
/* eslint-enable */
</script>

<style scoped>
#fieldtrialform:target {
  padding-top: 7vh;
}

.custom-footer button {
  font-family: "Mandrope", sans-serif;
}

#bottom_img {
  width: auto !important;
  width: 100%;
  max-width: 100%;
  float: left;
  clear: both;
}

@media screen and (max-width: 1397px) and (min-width: 860px) {
  #fieldtrialform:target {
    padding-top: 15vh;
  }
}

.reduceInputHeight {
  font-size: 11px;
  width: 100%;
  height: 50%;
  padding: 1em;
  border: 1px solid #e6e6e6;
  background-color: #e6e6e6;
}

.field_trial_header {
  background-color: #f4892f;
  color: white;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.field_trial_wrapper {
  width: 100%;
  border: 1px solid #dcdfe6;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.field_trial_body {
  width: 100%;
  border: 1px solid #dcdfe6;
}

.icon_socialmedia {
  height: 18px;
  padding-right: 5px;
}

h2 {
  margin: 0;
}

a {
  color: black;
}

.mail_crypt {
  unicode-bidi: bidi-override;
  direction: rtl;
}

* {
  box-sizing: border-box;
}

body {
  background: #f9c75c;
  color: #f4892f;
  line-height: 1.6;
  padding: 1em;
}

ul {
  list-style: none;
  padding: 0;
}

.brand {
  text-align: center;
}

.brand span {
  color: #fff;
}

.alert {
  text-align: center;
  padding: 10px;
  background: #79c879;
  color: #fff;
  margin-bottom: 10px;
  display: none;
}

.field_trial_body label {
  display: block;
}

.field_trial_body p {
  margin: 0;
}

button {
  border: 1px solid #e6e6e6;
  background-color: #e6e6e6;
  margin-left: 50px;
  margin-top: -50px;
  padding: 1em;
}

textarea,
option {
  width: 100%;
  height: 50%;
  padding: 1em;
  border: 1px solid #e6e6e6;
  background-color: #e6e6e6;
}

.phone {
  width: 100%;
  height: 30%;
  padding: 1em;
  border: 1px solid #e6e6e6;
  background-color: #e6e6e6;
}

select {
  width: 100%;
  height: 30%;
  padding: 1em;
  border: 1px solid #e6e6e6;
  background-color: #e6e6e6;
  font-size: 11px;
}

.field_trial_body form button {
  background: #f2f2f2;
  float: left;
  border: 0;
  border-radius: 4px;
  text-transform: uppercase;
}

.field_trial_body form button:hover,
.field_trial_body form button:focus {
  background: #b33d06;
  color: #fff;
  outline: 0;
  transition: background-color 2s ease-out;
  cursor: pointer;
}

/* LARGE SCREENS */
@media (min-width: 700px) {
  .field_trial_wrapper {
    display: grid;
  }

  .field_trial_wrapper > * {
    padding: 2%;
  }

  #bottom_img {
    position: relative;
    left: -2%;
    bottom: -5.5%;
    max-width: 104%;
  }

  .company-info h3,
  .company-info ul,
  .brand {
    text-align: left;
  }
}

@media screen and (max-width: 601px) {
  .field_trial_wrapper {
    display: block;
  }
}
@media screen and (max-width: 860px) {
}

.warning {
  color: red;
  font-weight: bolder;
}
</style>
